export default "__VITE_ASSET__Cro3al_d__"